import React from 'react';
import './NoAccess.scss';

const NoAccess: React.FC = () => {
  return (
    <main className='no-access-page'>
      <h1>Access denied</h1>
      <p>You are not allowed to view this page.</p>
    </main>
  );
};

export default NoAccess;
